import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountViewItemDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountViewItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountViewItemDTO.translate = translateService;
}
this.CashAccounts = [];
this.Date = null;
this.Code = null;
this.Description = null;
this.AA = null;
this.CashAccountViewItemDTOKey = null;
this._key = this.CashAccountViewItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
Code:any;
Description:any;
AA:any;
CashAccounts:any;
private _CashAccountViewItemDTOKey:any;
get CashAccountViewItemDTOKey(): any {
    return this._CashAccountViewItemDTOKey;
  }
set CashAccountViewItemDTOKey(value: any) {
    this._CashAccountViewItemDTOKey = value;
    this._key = value;
  }
static setCashAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.CashAccounts == null) $this.CashAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CashAccounts.length > 0) {
                    Domain.CashAccountViewItemDTO.removeCashAccounts($this, $this.CashAccounts[0]);
                }

                Domain.CashAccountViewItemDTO.addManyCashAccounts($this, copyItems);
            }
static addManyCashAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CashAccountViewItemDTO.addCashAccounts($this, items[i]);
                }
            }
static addCashAccounts = ($this, item) => {
                if ($this.CashAccounts == null) $this.CashAccounts = [];
                if (item == null || $this.CashAccounts.indexOf(item) > -1) return;
                $this.CashAccounts.push(item);
}
static addRangeCashAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CashAccountViewItemDTO.addCashAccounts($this, item));
            }
static removeCashAccounts = ($this, item) => {
                if ($this == null || $this.CashAccounts == null || $this.CashAccounts.indexOf(item) === -1) return;
                var _index = $this.CashAccounts.indexOf(item);
                $this.CashAccounts.splice(_index, 1);
}
static clearCashAccounts = ($this) => { $this.CashAccounts = null; }

static CreateEmpty(description: any,date: any): any{if (description == null) {description = "";}
let item = new Domain.CashAccountViewItemDTO();
item.Description = description;
item.Date = date;
item.AA = 0;
return item;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountViewItemDTOKey == null || $this.CashAccountViewItemDTOKey == 0;
            }


}